module.exports = __webpack_public_path__ + "img/background058.2a7afbb1.jpg";